<template>
    <section class="container-4xl-w mx-auto ">
        <Header  />
      
        
        <section class="grid grid-cols-12 sm:gap-2 flex container-4xl-w mx-auto px-2 min-h-[30rem] "  :class="isPhoneSize() ? 'mt-[6rem] mb-16' : 'mt-[9rem]'">
            <!-- breadcrump  -->
             <section class="col-span-12 sm:col-span-7 lg:col-span-9  min-h-6 max-h-8 flex items-center ">
                <categoryBreadCrump :key="refresh" :category_slug="route.params.name" />   
            </section>
          
           <!-- sort  -->
            <section class="sticky  bg-white pt-2 sm:pt-0 top-12 sm:block sm:top-0 col-span-12 sm:col-span-5 lg:col-span-3 px-2">
                 <!-- div content  -->
                <div class=" border-2 rounded-full  px-2 border-blue-200 flex items-center  cursor-pointer hover:bg-gray-200 h-8 relative " ref="dropdownContainer">
                       <!-- div for create select box  -->
                       <div class="flex items-center justify-between w-full " @click="sortKey=!sortKey">
                          <span class="flex public-text1-b flex items-center gap-1">
                             <span class="inline-block "> مرتب سازی بر اساس </span>
                              {{sortContent}}
                          </span>
                         <font-awesome-icon icon="chevron-down" class="mx-2 h-3 w-3  transition-transform duration-100" :class="sortKey?'rotate-180':''" />   
                       </div>
                       
                       <!-- select option  -->
                       <ul class="absolute transition-all duration-75  top-8 rounded-lg right-0 bg-white w-full list-none  overflow-hidden public-text " :class="sortKey?'border border-blue-200 border-2 py-1':'h-0'">
                             <li class="hover:bg-blue-400 hover:text-gray-100 px-2" @click="sortKey=false;sortContent='جدیدترین ها'">بر اساس جدیدترین ها </li>
                             <li class="hover:bg-blue-400 hover:text-gray-100 px-2" @click="sortKey=false;sortContent='ارزانترین ها'">بر اساس ارزانترین ها </li>
                             <li class="hover:bg-blue-400 hover:text-gray-100 px-2 my-1" @click="sortKey=false;sortContent='گرانترین ها'">بر اساس گرانترین ها </li>
                       </ul>
               </div>
          </section>
            
          <!-- body  -->
          <section class="col-span-12 min-h-[30rem]">
            <!-- template show loading  -->
            <template v-if="isLoading"> 

                <div class="fixed top-1/2  left-1/2  -translate-x-1/2  flex-center w-20 h-20 gap-2">
                  
                      <span class="relative flex h-3 w-3">
                         <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
                         <span class="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
                      </span>
    
                      <span class="relative flex h-3 w-3">
                         <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
                         <span class="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
                      </span>
                    
                      <span class="relative flex h-3 w-3">
                         <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75 "></span>
                         <span class="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
                      </span>

                </div>
             
            </template>

            <!-- template show data  -->
            <template v-else>
              <!-- template not found category  -->
              <template v-if="cat_loading">

                 <div class="fixed top-1/2  left-1/2  -translate-x-1/2">

                     <div class="flex flex-col items-center gap-2">
                         <p class="public-text">دسته بندی مورد نظر یافت نشد</p>
                         <router-link to="/" class="public-text hover:text-blue-500 inline-block rounded-lg shadow shadow-md hover:shadow-md hover:shadow-blue-500 p-2">بازگشت به صفحه اصلی</router-link>
                     </div>

                 </div> 

              </template>
              
              <!-- template show category  -->
              <template v-else>
                <section :style="isPhoneSize()?{ minHeight: 'calc(100vh - 16.5rem)' } : {}">
                  <section class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2" >
             
                    <div class="shadow shadow-blue-200 hover:shadow-lg hover:shadow-blue-200 transition"  v-for="(item, index)  in products.slice((page - 1) * perPage(4), page * perPage(4))" :key="index">
                         <router-link  :to="{ name: 'product', params: { name: item.slug } }"
                                :aria-label="item.name" class="block w-full px-4 py-3" >
                                 <article>
                                    <div class="h-8"></div>
                                    <div class="flex flex-row sm:flex-col">

                                        <div class=" w-32 sm:w-44 ml-3 sm:mx-auto">
                                            <div class="w-full ">
                                                <img v-lazy="{ src: 'https://parsinekala.com'+item.images[0].image, loading: require('@/assets/images/loadImage2.png'), error: 'your error image url' }"   :aria-label="item.slug"  class="w-full" :alt="item.slug" />
                                             </div>
                                        </div>

                                        <div class="sm:w-full overflow-hidden grow">
                                            <div class="h-4 w-full hiiden"></div>
                                            <div class="mb-2">

                                               <h3 class="h-12 sm:h-14 line-clamp-2 public-text1-b">
                                                  {{ item.name }}
                                               </h3>

                                           </div>
   
                                           <!-- discounted_price and precent  -->
                                           <div  class="h-8 w-full flex items-center justify-between mb-1">
                                      
                                                <div v-if="item.variations[0].discounted_price" class="public-text bg-red-600 rounded-full px-1 text-white overflow-hidden" >
                                                    {{ digitsEnToFa(Math.floor(((item.variations[0].price-item.variations[0].discounted_price)*100)/item.variations[0].price)) + '%' }}  
                                                </div>

                                               <div v-else>
                                                    &nbsp;
                                               </div>
   
                                               <div v-if="item.variations[0].discounted_price" class="flex items-center public-text1-b">
                                                   {{ digitsEnToFa(formatNumber(item.variations[0].discounted_price)) }}<span>تومان</span>
                                              </div>

                                              <div v-else class="flex items-center public-text1-b">
                                                  {{ digitsEnToFa(formatNumber(item.variations[0].price)) }}<span>تومان</span>
                                              </div>
                                           </div>

                                           <div v-show="item.variations[0].discounted_price"  class="h-8 w-full flex items-center public-text1-b justify-end pl-4 text-gray-400" >
                                             <del>{{ digitsEnToFa(formatNumber(item.variations[0].price)) }}</del>
                                           </div>
                                       </div>
                                    </div>
                                 </article>
                         </router-link>
                    </div>    
         
                  </section>
                </section>
   
                    <!-- bellow card is for v-pagination  -->
                   <section class="text-center  my-4 shadow shadow-blue-200 ">

                        <div  class="flex justify-center items-center py-2">

                          <button  @click="gototop1"
                          :disabled="page <= 1 ? true : false" class="mx-2"   >
                          <FontAwesomeIcon  icon="chevron-right" class="h-4 w-4" :style="{ color: page <= 1 ? '#ccc' : '#000' }" />
                        </button>
                        
                         <button
                            v-for="i in Math.ceil(products.length / perPage(4))" :key="i" @click="gototop(i)"  class="mx-1 public-text h-8 w-10 flex-center rounded-md   transition-all"
                            :class="page == i ? ' ring-2 ring-pink-500 hover:ring-red-400 hover:text-pink-500'  : 'ring-2 ring-gray-200  hover:ring-red-200'" >{{ digitsEnToFa(i) }}
                          </button>
                      
                         <button  @click="gototop2"  to="" :disabled="  Math.ceil(products.length/perPage(4)) == page ? true : false " class="mx-2" >
                            <FontAwesomeIcon  icon="chevron-left" class="h-4 w-4" :style="{ color: Math.ceil(products.length / perPage(4)) == page ? '#ccc' : '#000' }" />
                       
                         </button>
                        
                        </div>
                
                  </section>
                 

                  <section v-show="splitResolt.length" v-for="(n,index) in splitResolt" :key="index" >
                       <h1 class="public-text-title text-sky-950 text-justify mb-2" v-if="hashResoult(n)===1">
                            {{ digitsEnToFa(removeHash(n)) }}
                       </h1>

                       <h2 class="public-text-b text-sky-900 text-justify mt-2 mb-1 px-1" v-if="hashResoult(n)===2">
                            {{ digitsEnToFa(removeHash(n)) }} 
                       </h2>

                       <h3 class="public-text text-sky-800 text-justify mt-2 mb-[2px] px-2" v-if="hashResoult(n)===3">
                            {{ digitsEnToFa(removeHash(n)) }} 
                       </h3>

                       <p  class="public-text text-gray-600 text-justify px-4" v-if="!hashResoult(n)">
                            {{ digitsEnToFa(n) }}
                       </p>

                       

                  </section>

                  <!-- divider  -->
                  <div v-show="splitResolt.length && !isPhoneSize" class="border border-blue-200 w-full my-4 "></div>

                  <!-- extraText  -->
                  <textTopFooter />

                  <!-- divider  -->
                  <div v-show="isPhoneSize" class=" w-full mb-4 bg-blue-200"></div>


              </template>
             
           </template>

          </section>
      </section>

      <Footer  v-if="!isPhoneSize()" />

      <phoneHeader v-else />


    </section>
    
    </template>
  <script setup>
import { onMounted,ref,onUnmounted,watch} from 'vue';

import Header from '@/components/Header/headerSection.vue'

import Footer from '@/components/Footer/footerSection.vue';

import phoneHeader from '@/components/Footer/phoneFooter';

import { isPhoneSize } from '@/utils/isPhoneSize';

import categoryBreadCrump from './categoryBreadCrump.vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { digitsEnToFa } from "persian-tools";

import { useRoute,useRouter } from 'vue-router';

import { useHead } from "@vueuse/head";

 import axios from "axios";
 import { useCookies } from "vue3-cookies";
 const { cookies } = useCookies();
 axios.defaults.withCredentials = true;
 axios.defaults.headers.common["X-CSRFToken"] = cookies.get("csrftoken");

 const router = useRouter();

 const meta_description = ref("دسته بندی محصولات");

 const description=ref('')

 const category=ref([]);

 const allProduct=ref([]);

 const route=useRoute()

//  sortKey  is for open and close sort menu
 const sortKey=ref(false);

// sortContent useed for save cortMenu content 
 const sortContent=ref('');

 // refresh foe change breadcrump 
 const refresh=ref(0)

 // dropdownContainer for select sort menu 
 const dropdownContainer = ref(null);

 import textTopFooter from '@/components/extraText/textTopFooter.vue';

 // products for save products 
 const products = ref([]);
 
 // cat_slug for save category content 
 const cat_slug = ref([]);

 const hover = ref([]);
const heart = ref([]);

const formatNumber = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "،");
};

// start code for split category description 
  const splitResolt=ref([])
  const splitDescription=(e)=>{
    splitResolt.value=e.split('$$')
  }

  const hashResoult = (e) => {
  if (typeof e !== 'string') return 0;  // Return 0 if e is not a string
  return (e.match(/#/g) || []).length;
};

const removeHash=(e)=>{
  if (typeof e !== 'string') return '';
     return (e.replace(/#/g, ''))
}
//  end code for split category description 


// heart_func for set good product 
const heart_func = (e, i) => {
  if (localStorage.getItem("myList")) {
    let fav = JSON.parse(localStorage.getItem("myList"));
    let result = fav.indexOf(e.id);
    if (result > -1) {
      heart.value[i] = true;
    } else {
      heart.value[i] = false;
    }
  } else {
    heart.value[i] = false;
  }
};

    const setItem=async()=>{
           try {
             const response = await axios.post("https://parsinekala.com/backend/api/categories/");   
             category.value=response.data;
               if (category.value !== null) {
                    for (let i = 0; i < category.value.length; i++) {    
                          if (category.value[i].slug === route.params.name){
                               cat_loading.value=false;
                               meta_description.value = category.value[i].meta_description;
                               description.value=category.value[i].description;
                              splitDescription(category.value[i].description);
                              break;
                         }
                     }
                 }
 
                 try {  
                     const response=await axios.post("https://parsinekala.com/backend/api/products/");
                        allProduct.value=response.data
                    
                      if(route.params.name==='همه-محصولات'){
                         allProduct.value.forEach((e,index) => {          
                           // Update the products array and other related data
                           products.value[index] = e;
                           heart_func(e, index);
                           hover.value[index] = false;
                       });
                           meta_description.value='مشاهده همه محصولات و خرید انئاع لباس ست ورک،لی، کتان و تجهیزات ایمنی از فروشگاه اینترنتی پارسینه کالا کالا';
                           cat_loading.value=false;
                        
                      }
                      else{     
                        let i = 0;
                        allProduct.value.forEach((e) => {
                         if(e.slug.includes('لباس-کار') && route.params.name==='لباس-کار'){
         
                          products.value[i] = e;
                            heart_func(e, i);
                            hover.value[i] = false;
                            i += 1;
                         }else if (e.category.slug === route.params.name) {
                            // Update the products array and other related data
                            products.value[i] = e;
                            heart_func(e, i);
                            hover.value[i] = false;
                            i += 1;
                          }
                        });
                        }
                




                          if (!products.value.length) {
                               if (category.value.length) {
                                 category.value.forEach((e) => {
                                   if (e.slug === route.params.name) {
                                     cat(e.id);
                                   }
                                 });
                               }
                          let i=0;
                          if (cat_slug.value.length) {
                            products.value = [];
                            allProduct.value.forEach((e) => {
                              cat_slug.value.forEach((e2) => {
                                if (e.category.slug === e2) {
                                  products.value[i] = e;
                                  heart_func(e, i);
                                  hover.value[i] = false;
                                  i += 1;
                                }
                              });
                            });
                          }
                        }
                
           
                  } catch (error) {
                         console.error("Error fetching product data.");
           
                   }

           } catch (error) {
              console.log(error)
           }finally{
              isLoading.value = false; // Data has been fetched
           }


   }
    

    
    const gototop1 = () => {
  page.value -= 1;
  router.push({ ...route });
};
const gototop = (e) => {
  page.value = e;
  router.push({ ...route });
};
const gototop2 = () => {
  page.value += 1;
  router.push({ ...route });
};
const page = ref(1);
const perPage =(x)=>{
  if(x==4)
  return 20
else 
return 9
}





// cat for set  cat_slug
const cat = (id) => {
  if (category.value.length) {
    category.value.forEach((e) => {
      if (e.sub_category === id) {
        cat_slug.value.push(e.slug);
        cat(e.id);
      }
    });
  }
};
const isLoading = ref(true);
const cat_loading = ref(true);

onMounted(() => {
  setItem();
  useHead({
  link:{
    rel: "canonical",
    href: encodeURI("https://parsinekala.com/category/"+route.params.name),
  },
  meta: [{ name: "description", content: meta_description }],
});
      document.addEventListener('click', closeDropdown)
    })



watch([() => route.params.name,()=>sortContent.value],async()=>{    
  refresh.value+=1;
  isLoading.value=true;
    products.value = [];
    heart.value = [];
    hover.value = [];
    cat_loading.value=true;
   
      try {
  
        const response=await axios.post("https://parsinekala.com/backend/api/products/");
        allProduct.value=response.data;


        for (let i = 0; i < category.value.length; i++) {
        if (category.value[i].slug === route.params.name) {
          cat_loading.value=false;
          meta_description.value = category.value[i].meta_description;
          description.value=category.value[i].description;
          splitDescription(category.value[i].description);

          break;
        }
    
      }

      if (allProduct.value !== null) {
          if(sortContent.value=== 'ارزانترین ها'){
        let temp
       for(let i=0;i<allProduct.value.length-1;i++){
        for(let j=i+1;j<allProduct.value.length;j++){
          if(return_price(allProduct.value[i].variations[0])>return_price(allProduct.value[j].variations[0])){
             temp=allProduct.value[i];
             allProduct.value[i]=allProduct.value[j];
             allProduct.value[j]=temp;
          }
        }
       }
        }
        if(sortContent.value==='گرانترین ها'){
       
      let temp
       for(let i=0;i<allProduct.value.length-1;i++){
        for(let j=i+1;j<allProduct.value.length;j++){
          if(return_price(allProduct.value[i].variations[0])<return_price(allProduct.value[j].variations[0])){
             temp=allProduct.value[i];
             allProduct.value[i]=allProduct.value[j];
             allProduct.value[j]=temp;
          }
        }
       }
   }
   if(sortContent.value==='جدیدترین ها'){
      let temp
       for(let i=0;i<allProduct.value.length-1;i++){
        for(let j=i+1;j<allProduct.value.length;j++){
          if(allProduct.value[i].id<allProduct.value[j].id){
             temp=allProduct.value[i];
             allProduct.value[i]=allProduct.value[j];
             allProduct.value[j]=temp;
          }
        }
       }
   }
     
                       if(route.params.name==='همه-محصولات'){
                         allProduct.value.forEach((e,index) => {          
                           // Update the products array and other related data
                           products.value[index] = e;
                           heart_func(e, index);
                           hover.value[index] = false;
                       });
                           meta_description.value='مشاهده همه محصولات و خرید انئاع لباس ست ورک،لی، کتان و تجهیزات ایمنی از فروشگاه اینترنتی پارسینه کالا کالا';
                           cat_loading.value=false;
                        
                      }
                      else{     
                        let i = 0;
                        allProduct.value.forEach((e) => {
                         if(e.slug.includes('لباس-کار') && route.params.name==='لباس-کار'){
         
                          products.value[i] = e;
                            heart_func(e, i);
                            hover.value[i] = false;
                            i += 1;
                         }else if (e.category.slug === route.params.name) {
                            // Update the products array and other related data
                            products.value[i] = e;
                            heart_func(e, i);
                            hover.value[i] = false;
                            i += 1;
                          }
                        });
                        }
                

  }else{
    cat_slug.value = [];
          if (category.value.length) {
            category.value.forEach((e) => {
              if (e.slug === route.params.name) {
                cat(e.id);
              }
            });
          }

          if (cat_slug.value.length) {
            let i = 0;
            allProduct.value.forEach((e) => {
              cat_slug.value.forEach((e2) => {
                if (e.category.slug === e2) {
                  products.value[i] = e;
                  heart_func(e, i);
                  hover.value[i] = false;
                  i += 1;
                }
              });
            });
          }
  }


        
      } catch (error) {
        console.log()
      }finally{
        isLoading.value=false;
      }
      useHead({
  link:{
    rel: "canonical",
    href: encodeURI("https://parsinekala.com/category/"+route.params.name),
  },
  meta: [{ name: "description", content: meta_description }],
});
})




    const closeDropdown = (event) => {
      if (event.type === 'resize' || !dropdownContainer.value.contains(event.target)) {
        sortKey.value = false
      }
    }

    const return_price=(x)=>{
  if(x.discounted_price){
    return x.discounted_price
  }else{
    return x.price
  }

}

    onMounted(() => {
      setItem();
      document.addEventListener('click', closeDropdown);
      window.addEventListener('resize', closeDropdown);
 
    })

    onUnmounted(() => {
      document.removeEventListener('click', closeDropdown);
      window.removeEventListener('resize', closeDropdown);
    });

    </script>
    <style scoped></style>
    